import React, { useEffect, useState } from "react";
import * as api from "../api";

export default function CallTypeDropdown({
  value,
  onChange,
  emit = "code",
  includeAll = false,
  allLabel = "Всички видове",
}) {
  const [types, setTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const data = await api.listCallTypes();
        setTypes(Array.isArray(data) ? data.filter(t => t.active) : []);
        setError("");
      } catch (e) {
        console.error(e);
        setError("Грешка при зареждане на типовете");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const selectValue = (() => {
    if (emit === "code") return value || "";
    if (emit === "name") {
      const found = types.find(t => t.name === value);
      return found?.code || "";
    }
    if (emit === "obj") return value?.code || "";
    return value || "";
  })();

  const makeReturnValue = (code) => {
    const t = types.find(x => x.code === code);
    if (!t) return emit === "obj" ? { code: "", name: "" } : (emit === "name" ? "" : "");
    if (emit === "name") return t.name;
    if (emit === "obj") return { code: t.code, name: t.name, description: t.description };
    return t.code;
  };

  const handleChange = (e) => {
    const code = e.target.value;
    onChange?.(makeReturnValue(code));
  };

  return (
    <div className="space-y-1 w-full">
      <div className="relative">
        <select
          className="bg-[#121825] border border-[#1f2638] rounded-xl px-3 py-2 text-sm text-white outline-none 
                 focus:ring-2 focus:ring-violet-600/40 w-full"
          value={selectValue}
          onChange={handleChange}
          disabled={loading}
        >
          {includeAll
            ? <option value="">{loading ? "Зареждане…" : allLabel}</option>
            : <option value="">{loading ? "Зареждане…" : "Изберете тип"}</option>
          }
          {types.map(t => (
            <option key={t.code} value={t.code}>{t.name}</option>
          ))}
        </select>
        {error && <p className="text-xs text-rose-400 mt-1">{error}</p>}
      </div>
    </div>
  );
}
